import { render, staticRenderFns } from "./AidocList.vue?vue&type=template&id=27ade20c&scoped=true"
import script from "./AidocList.vue?vue&type=script&lang=js"
export * from "./AidocList.vue?vue&type=script&lang=js"
import style0 from "./AidocList.vue?vue&type=style&index=0&id=27ade20c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ade20c",
  null
  
)

export default component.exports